import { Component } from "react";
import { RefreshCw } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

// Hydration-Hinweise (#418/#423/#425) sind keine Fehler: React rendert bei Bot-Vorab-HTML einfach neu. Bots selbst melden wir gar nicht.
const IGNORE = /Minified React error #(418|423|425)|Hydration failed|hydrat/i;
const BOT = /bot|spider|crawl|slurp|headless|lighthouse|prerender/i;
export const reportClientError = (payload) => {
  if (IGNORE.test(String(payload?.message || "")) || BOT.test(navigator.userAgent)) return;
  try {
    fetch(`${API}/client-error`, { method: "POST", credentials: "include", headers: { "Content-Type": "application/json" }, keepalive: true,
      body: JSON.stringify({ url: window.location.href, ua: navigator.userAgent, ...payload }) }).catch(() => {});
  } catch { /* nie werfen */ }
};

let hooked = false;
/* Benigner Browser-Hinweis (Chrome/Safari), kein Programmfehler: Layout ändert sich im selben Frame erneut (z. B. Modal + Scroll-Sperre). Wird vor Dev-Overlay und Fehlerbericht gestoppt. */
const RO_HINWEIS = /ResizeObserver loop (limit exceeded|completed with undelivered notifications)/;

export const installErrorReporting = () => {
  if (hooked || typeof window === "undefined") return;
  hooked = true;
  window.addEventListener("error", (e) => { if (RO_HINWEIS.test(String(e.message || ""))) { e.stopImmediatePropagation(); e.preventDefault(); } }, true);
  window.addEventListener("error", (e) => reportClientError({ kind: "window", message: String(e.message || e.error || "Fehler"), stack: e.error?.stack }));
  window.addEventListener("unhandledrejection", (e) => reportClientError({ kind: "promise", message: String(e.reason?.message || e.reason || "Promise-Fehler"), stack: e.reason?.stack }));
};

export class ErrorBoundary extends Component {
  constructor(props) { super(props); this.state = { error: null }; }
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) { reportClientError({ kind: "render", message: String(error?.message || error), stack: error?.stack, component_stack: info?.componentStack }); }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="p-card p-6 md:p-8 border-2 border-[#9B2C2C]/40 bg-[#FDF2F2]" data-testid="error-boundary">
        <p className="label-text mb-1 text-[#9B2C2C]">Da ist etwas schiefgelaufen</p>
        <h3 className="font-display text-xl text-[#111]">{this.props.title || "Dieser Bereich konnte nicht angezeigt werden."}</h3>
        <p className="text-sm text-[#5C574F] mt-1">Der Fehler wurde automatisch an uns gemeldet. Ihre Eingaben sind gespeichert – bitte die Seite neu laden.</p>
        <p className="mt-2 text-xs text-[#9B2C2C] font-mono break-all" data-testid="error-boundary-message">{String(this.state.error?.message || this.state.error)}</p>
        <button type="button" onClick={() => window.location.reload()} className="p-btn p-btn-primary mt-4 !text-xs" data-testid="error-boundary-reload"><RefreshCw size={13} /> Seite neu laden</button>
      </div>
    );
  }
}
